// Project assemblies keyed by id. Rows are created from paint/welding inspections.
import { GET_PROJECT_ASSEMBLIES, GET_PROJECT_ASSEMBLY_AND_LAST_WI } from "./actions";

export function ProjectAssembliesReducer(state = {}, action) {
  switch (action.type) {
    case `${GET_PROJECT_ASSEMBLIES}_FULFILLED`: {
      return _.mapKeys(action.payload.data, "id");
    }
    case `${GET_PROJECT_ASSEMBLY_AND_LAST_WI}_FULFILLED`: {
      let newState = _.clone(state);
      const newItem = action.payload.data;
      const id = _.get(newItem, "id");
      newState[id] = newItem;
      return newState;
    }
    default:
      return state;
  }
}
